import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useQueryClient } from '@tanstack/react-query'
import toast from 'react-hot-toast'

const MESSAGES = {
  connected: ['success', 'Gmail connecté : vos e-mails partiront de votre compte Gmail.'],
  denied: ['error', 'Connexion Gmail annulée.'],
  missing_scope: ['error', 'Cochez l’autorisation « Envoyer des e-mails » sur l’écran Google pour connecter Gmail.'],
  expired: ['error', 'La demande de connexion Gmail a expiré : relancez-la.'],
  error: ['error', 'La connexion Gmail a échoué : réessayez.'],
}

/** Retour de « Connecter Gmail » (?gmail=<résultat>) : message, puis paramètre retiré de l'URL. */
export default function GmailConnectResult() {
  const location = useLocation()
  const navigate = useNavigate()
  const queryClient = useQueryClient()

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    const result = params.get('gmail')
    if (!result) return
    const [kind, message] = MESSAGES[result] ?? MESSAGES.error
    toast[kind](message)
    if (result === 'connected') queryClient.invalidateQueries()
    params.delete('gmail')
    const search = params.toString()
    navigate({ pathname: location.pathname, search: search ? `?${search}` : '' }, { replace: true })
  }, [location.search]) // eslint-disable-line react-hooks/exhaustive-deps

  return null
}
